import React,{Component} from 'react';

import './ArchiveContent.css';

import { background_1, image2 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import Counters from '../../components/Counters/Counters';
import LiveMissions from './content/LiveMissions/LiveMissions';
import OnlineMissions from './content/OnlineMissions/OnlineMissions';
import HistoricalDatasets from './content/HistoricalDatasets/HistoricalDatasets';
import HistoricalArchive from './content/HistoricalArchive/HistoricalArchive';
import { connect } from 'react-redux';
import { get_global_stats_counter } from '../../utils/data';
import IngestionCharts from './content/IngestionCharts/IngestionCharts';
import GlobalStats from '../../components/GlobalStats/GlobalStats';
import { Helmet } from 'react-helmet';
import { get_page_title } from '../../utils/config';

interface Props{
    // redux
    data:any
}
interface State{
}

class ArchiveContent extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state={
        }
    }
    render(){
        let tabs = [

            {
                // 1
                label: <>Ingestion Charts</>,
                content: <div className="archive-content-content">
                    <IngestionCharts/>
                </div>
            },


            {
                // 2
                label: <>Archive Composition</>,
                content: <div className="archive-content-content">
                    <HistoricalArchive/>
                </div>
            },

            {
                // 3
                label: <>Historical Dataset List</>,
                content: <div className="archive-content-content">
                    <HistoricalDatasets csv='ingestion_dataset_detail_v3.csv' />
                </div>
            },

            {
                label: <>Live Mission Products List</>,
                content: <div className="archive-content-content">
                    <LiveMissions/>
                </div>
            },
            {
                label: <>Online Mission Products List</>,
                content: <div className="archive-content-content">
                    <OnlineMissions/>
                </div>
            },

            {
                label: <>Deleted Dataset List</>,
                content: <div className="archive-content-content">
                    <HistoricalDatasets csv='deleted_dataset_detail_v1.csv'/>
                </div>
            },
            
            {
                label: <>Archive Integrity</>,
                content: <div className="archive-content-content">
                    <h2 className="title-3">Integrity of the archive: offline verifications</h2>
                    <p>
                        In order to guarantee the integrity of the archive and hence the long-term preservation of the data, two offline 
                        checks are performed every month:
                    </p>
                    <ul>
                        <li>
                            0.1 % of the products on tape is retrieved and their checksums are verified vs the reference 
                            values in the Data Management System (DMS). The sample is built by selecting the tapes based on their 
                            import date (older) or testing date, if already (long time ago) tested. Subsequently, the files are 
                            randomly sampled in each tape to reach the expected number of products to be verified.
                        </li>
                        <li>
                            10% of data on tape is randomly selected from the DMS and the checksums stored in the metadata file 
                            system are compared with the ones in the DMS. In this case, the test checks if the file referenced in 
                            DMS exists in file system and has not been changed (checksum check). Every year, a full check is performed.
                        </li>
                    </ul>
                        
                    <h2 className="title-3">Maintaining healthy media for Long-Term Data Preservation</h2>
                    
                    <p>
                        In addition to those two offline verifications, an automatic check (Automated Media Health Checks) 
                        is performed by the library using the Scalar® Extended Data Life Management (EDLM) in background.
                        EDLM proactively checks the health of data on tape cartridges. It automates the data integrity scanning 
                        process that runs entirely in the background without interruption of production processes. EDLM enables 
                        a set-and-forget operation to ensure the data health during long-term storage over multiple years.
                    </p>

                </div>
            }
        ]
        return (
        <Page 
            id="archive-content"
            banner={{
                title: "archive content",
                bannerImage: background_1,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title('DAMPS - Archive Content') }</title>
                <meta 
                    name="description" 
                    content="DAMPS archive content: charts, datasets, live missions, online missions, deleted datasets, archive integrity"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    <GlobalStats/>
                </div>
                <div className="centered-content padding">
                    <Tabs tabs={tabs}/>
                </div>
            </div>
        </Page>
        );
    }

};
export default connect((state:any)=>{
    return {
        data: state.data
    }
})(ArchiveContent)